import { render, staticRenderFns } from "./paykanban.vue?vue&type=template&id=6184abac&"
import script from "./paykanban.vue?vue&type=script&lang=js&"
export * from "./paykanban.vue?vue&type=script&lang=js&"
import style0 from "./paykanban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports